import { createContext, useContext, useState } from 'react';

const ChatContext = createContext(null);
export const useChat = () => useContext(ChatContext);

export const DEFAULT_CHAT = 'Hello Ke-Sa, I have a question about your jewellery.';

export function ChatProvider({ children }) {
  const [message, setMessage] = useState(DEFAULT_CHAT);
  return <ChatContext.Provider value={{ message, setMessage }}>{children}</ChatContext.Provider>;
}
